import React, { createContext, useContext } from 'react';

var TranslationContext = createContext({});

export function TranslationProvider({ translations, children }) {
  return (
    <TranslationContext.Provider value={translations || {}}>
      {children}
    </TranslationContext.Provider>
  );
}

export function useTranslations() {
  return useContext(TranslationContext);
}
